/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum OrderServiceExceptionStatus {
    Open = 100,
    Assigned = 110,
    Resolved = 120,
    Cancelled = 170,
}
